// @flow
import React from 'react';
import { TABLEFLOW_RESOURCES_GRID_FIELDNAMES } from '@streaming-projects/orgs/enums';
import { TextField } from '@src/formik-utils/FormFields';

import { TABLEFLOW_RESOURCE_INPUTS_DETAILS_CONFIG_MAP } from './tableflow-resource-inputs-config';

export const SPTableFlowResourceNameContainer = ({
  disabled,
  disableOnFormErrors = null,
  fluid = null,
}) => {
  const { backendFieldName, displayName, icon } = TABLEFLOW_RESOURCE_INPUTS_DETAILS_CONFIG_MAP.get(
    TABLEFLOW_RESOURCES_GRID_FIELDNAMES.NAME
  );
  return (
    <TextField
      disableOnFormErrors={disableOnFormErrors}
      disabled={disabled}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
      fluid={fluid}
      icon={icon}
    />
  );
};
